/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Information We Collect`)
};

const es_privacy_section_2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Información que Recopilamos`)
};

const de_privacy_section_2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Informationen, die wir erfassen`)
};

const nl_privacy_section_2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Informatie die we verzamelen`)
};

const fr_privacy_section_2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Informations que nous collectons`)
};

const it_privacy_section_2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Informazioni che raccogliamo`)
};

const pt_br2_privacy_section_2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Informações que coletamos`)
};

const pt_privacy_section_2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Informação que recolhemos`)
};

const ja_privacy_section_2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. 収集する情報`)
};

const zh_privacy_section_2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. 我们收集的信息`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_2_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_2_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_2_title", locale)
	if (locale === "en") return en_privacy_section_2_title(inputs)
	if (locale === "es") return es_privacy_section_2_title(inputs)
	if (locale === "de") return de_privacy_section_2_title(inputs)
	if (locale === "nl") return nl_privacy_section_2_title(inputs)
	if (locale === "fr") return fr_privacy_section_2_title(inputs)
	if (locale === "it") return it_privacy_section_2_title(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_2_title(inputs)
	if (locale === "pt") return pt_privacy_section_2_title(inputs)
	if (locale === "ja") return ja_privacy_section_2_title(inputs)
	return zh_privacy_section_2_title(inputs)
};